import { PatientActions } from 'src/redux/actions/constant';

const { REQUEST_PATIENT_ID } = PatientActions;

const intialTitle = '';

export const getPatientIdReducer = (state = intialTitle, action: any) => {
  switch (action.type) {
    case REQUEST_PATIENT_ID: {
      return action.payload;
    }

    default:
      return state;
  }
};